import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { SecondaryButton } from "@stacc/flow-ui-components"
import { Icons } from "@stacc/flow-ui-components"

import files from "../../services/files";

import downloadLink from "../../utils/downloadLink";

const DownloadButtonStyled = styled(SecondaryButton)`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    padding-right: 1em;
  }
`;

interface DownloaDButtonProps {
  title: string
  fileId: string
}

const DownloadButton = ({ fileId, title }: DownloaDButtonProps) => {

  function onDownloadClick(e: any) {
    e.preventDefault();

    files.getFileMetadata(fileId).then((response: any) => {
      if (!response) {
        console.error("Error getting file meta data");
        return;
      }

      const metadata = response.data;
      const { filename } = metadata;

      files.getFile(fileId).then(result => {
        if (result && result.file) {
          return downloadLink(result.file, filename);
        }
        return null;
      });
    });
  }


  return (
    <DownloadButtonStyled size="large" onClick={(e) => onDownloadClick(e)}>
      <Icons.FilePdf />
      {title}
    </DownloadButtonStyled>
  );
}


DownloadButton.propTypes = {
  fileId: PropTypes.string.isRequired,
  title: PropTypes.string
};

DownloadButton.defaultProps = {
  title: "Download file"
};

export default DownloadButton;